<div class="card">
    <h1>Concordance over time <p-toggleButton [(ngModel)]="checked" onLabel="Show By Strain" offLabel="Show By Reference" (onChange)="handleChange($event)"></p-toggleButton></h1>
    <div style="text-align: center;">
        <p-progressSpinner *ngIf="showSpinner"></p-progressSpinner>
    </div>
    <p-chart *ngIf="!showSpinner" type="line" [data]="data" height="80vh"></p-chart>
</div>
